import baseService from '@/utils/http/axios'
import { baseURL } from '@/utils/util'

export const userLogin1 = data => {
  console.trace('userLogin1 被调用'); // 打印调用栈
  const api = baseURL + `auth/unlock`
  return baseService.post(api, data)
}
// 模拟的目标数据结构（作为映射模板）
const mockUserInfo = {
  "id": "4291d7da9005377ec9aec4a71ea837f",
  "name": "admin",
  "username": "LVQ",
  "password": "",
  "avatar": "/user.png",
  "status": 1,
  "telephone": "",
  "lastLoginIp": "27.154.74.117",
  "lastLoginTime": 1534837621348,
  "creatorId": "admin",
  "createTime": 1497160610259,
  "merchantCode": "TLif2btpzg079h15bk",
  "deleted": 0,
  "permission": [
    "admin"
  ],
  "token": "12312312",
  "menu": [
    {
      "name": "dashboard",
      "parentId": 0,
      "id": 1,
      "meta": {
        "icon": "bx-analyse",
        "title": "仪表盘",
        "show": true
      },
      "component": "RouteView",
      "redirect": "/dashboard/workplace"
    },
    {
      "name": "workplace",
      "parentId": 1,
      "id": 7,
      "meta": {
        "title": "工作台",
        "show": true
      },
      "component": "Workplace"
    }
  ]
};

// 直接使用相对路径，由baseService和代理自动处理完整地址
// api/user.ts 正确写法
export const userLogin = async (data) => {
  try {
    let formData = new FormData();
    formData.append('code', data.username);   // 与 Apifox 相同的参数名
    formData.append('pass', data.password);   // 与 Apifox 相同的参数名    
    // 调用真实接口
    const response = await baseService.post('/api/user/login/', formData);
    // 注意：新结构中实际用户数据在 response.data.data.result 里
    const originalData = response.data?.result || {};
    const apiResponse = response.data; // 保留接口的状态和消息

    // 将原始数据映射到目标格式
    const transformedData = {
      // 从 result 中提取字段
      id: originalData.UserID || mockUserInfo.id,
      name: originalData.Name || mockUserInfo.name,
      username: originalData.Code || mockUserInfo.username,
      password: mockUserInfo.password,
      avatar: mockUserInfo.avatar,
      status: originalData.islogin ? 1 : 0,
      telephone: originalData.phone || mockUserInfo.telephone,
      lastLoginIp: mockUserInfo.lastLoginIp,
      lastLoginTime: Date.now(),
      creatorId: mockUserInfo.creatorId,
      createTime: mockUserInfo.createTime,
      merchantCode: mockUserInfo.merchantCode,
      deleted: mockUserInfo.deleted,
      permission: mockUserInfo.permission,
      token: originalData.token || mockUserInfo.token,
      menu: mockUserInfo.menu,
      
      // 保留接口返回的状态和消息（可选）
      apiStatus: apiResponse.status,
      apiMessage: apiResponse.message
    };
    
    return { unlocked: true };
    // return {
    //   ...response,
    //   data: transformedData
    // };
  } catch (error) {
    return Promise.reject(error);
  }
};